module.exports = __webpack_public_path__ + "img/fabulous-blintz-souffle.f11c6fd5.jpg";